import React, { Component } from 'react';


import DetailLineComponent from './../components/ChartDetailLineDashboard/DetailLineComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';

import {colors} from './datos'
     // 
//Actualizacion develop
class DetailLineDB extends Component {        
        
    render() { 
        const {data, name, title} = this.props;
        
       return (
        <DetailLineComponent 
            watchMenu={this.props.watchMenu}
            name={name}
            title={title}
            data={data}
            onClickGraphic={this.props.onClickGraphic}
            seeMore={this.props.seeMore}            
            openDialog={this.props.openDialog}
            colors={colors}
        />
        );
    }
}

export default DetailLineDB;